/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumTaxType = exports.PremiumInvoiceStatusType = exports.PremiumAssetType = exports.IntervalUnit = exports.Disclaimer = void 0;
var Disclaimer;
(function (Disclaimer) {
    Disclaimer["UNKNOWN"] = "UNKNOWN";
    Disclaimer["DISCOUNT"] = "DISCOUNT";
    Disclaimer["EXEMPTION"] = "EXEMPTION";
    Disclaimer["BRAZIL_ENF_DEPRECATION"] = "BRAZIL_ENF_DEPRECATION";
})(Disclaimer = exports.Disclaimer || (exports.Disclaimer = {}));
var IntervalUnit;
(function (IntervalUnit) {
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    IntervalUnit["DAY"] = "DAY";
    IntervalUnit["WEEK"] = "WEEK";
    IntervalUnit["MONTH"] = "MONTH";
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit = exports.IntervalUnit || (exports.IntervalUnit = {}));
var PremiumAssetType;
(function (PremiumAssetType) {
    PremiumAssetType["UNKNOWN"] = "UNKNOWN";
    PremiumAssetType["PLAN"] = "PLAN";
    PremiumAssetType["DOMAIN"] = "DOMAIN";
    PremiumAssetType["MAILBOX"] = "MAILBOX";
    PremiumAssetType["APP"] = "APP";
    PremiumAssetType["CATALOG_PRODUCT"] = "CATALOG_PRODUCT";
    PremiumAssetType["DIGITAL_GOOD"] = "DIGITAL_GOOD";
    PremiumAssetType["BIG_STOCK_IMAGE"] = "BIG_STOCK_IMAGE";
    PremiumAssetType["SHUTTER_STOCK_IMAGE"] = "SHUTTER_STOCK_IMAGE";
    PremiumAssetType["SHUTTER_STOCK_VIDEO"] = "SHUTTER_STOCK_VIDEO";
    PremiumAssetType["WIX_IMAGE"] = "WIX_IMAGE";
    PremiumAssetType["WIX_VIDEO"] = "WIX_VIDEO";
    PremiumAssetType["WIX_LOGO"] = "WIX_LOGO";
})(PremiumAssetType = exports.PremiumAssetType || (exports.PremiumAssetType = {}));
var PremiumInvoiceStatusType;
(function (PremiumInvoiceStatusType) {
    PremiumInvoiceStatusType["UNKNOWN"] = "UNKNOWN";
    PremiumInvoiceStatusType["PAID"] = "PAID";
    PremiumInvoiceStatusType["REFUND"] = "REFUND";
    PremiumInvoiceStatusType["CHARGEBACK"] = "CHARGEBACK";
    PremiumInvoiceStatusType["REFUND_FROM_CHANGE_PLAN"] = "REFUND_FROM_CHANGE_PLAN";
})(PremiumInvoiceStatusType = exports.PremiumInvoiceStatusType || (exports.PremiumInvoiceStatusType = {}));
var PremiumTaxType;
(function (PremiumTaxType) {
    PremiumTaxType["UNKNOWN"] = "UNKNOWN";
    PremiumTaxType["REGULAR"] = "REGULAR";
    PremiumTaxType["VAT"] = "VAT";
    PremiumTaxType["JCT"] = "JCT";
    PremiumTaxType["GST"] = "GST";
    PremiumTaxType["TIN"] = "TIN";
    PremiumTaxType["HST"] = "HST";
    PremiumTaxType["PST"] = "PST";
    PremiumTaxType["QST"] = "QST";
    PremiumTaxType["SST"] = "SST";
    PremiumTaxType["TRN"] = "TRN";
    PremiumTaxType["TW_VAT"] = "TW_VAT";
    PremiumTaxType["AU_GST"] = "AU_GST";
    PremiumTaxType["IN_GST"] = "IN_GST";
    PremiumTaxType["BR_CNPJ"] = "BR_CNPJ";
    PremiumTaxType["IGIC_VAT"] = "IGIC_VAT";
    PremiumTaxType["KE_VAT"] = "KE_VAT";
    PremiumTaxType["PE_VAT"] = "PE_VAT";
})(PremiumTaxType = exports.PremiumTaxType || (exports.PremiumTaxType = {}));
//# sourceMappingURL=types.js.map